import cs from 'classnames';

import type { IBoxProps } from '@/DesignSystem/Model/DataModel';

export const generateBoxClassNames = ({ className, color, hover }: IBoxProps) => {
  return cs('ui__box', color && `ui__box--color-${color}`, hover && `ui__box--hover`, className);
};
